/* eslint-disable react-hooks/exhaustive-deps */
import React, {useEffect, useReducer} from "react";
import {Button} from "primereact/button";
import useApiDirecciones from "../../api/catalogos/useApiDirecciones";
import Direccion from "../../catalogos/direccion";
import direccionValidacionEsquema from "./direccionValidacionEsquema";
import formReducer from "../../shared/forms/formReducer";
import FormHandler from "../../shared/forms/formHandler";
import FieldDropDown from "../../shared/controls/fieldDropDown";
import ReadOnlyProvider from "../../shared/forms/ReadOnlyProvider";
import alerts from "../../shared/alerts";
import constantes from "../constantes";

const defaultEntity = () => ({
    entity: {
        direccion: {colonia: "NA"}
    }
});

const DetalleDireccion = ({direccionId, onSave, soloLectura}) => {
    const guid = Math.random();

    const [{entity, errors}, dispatch] = useReducer(
        formReducer, {}, defaultEntity
    );

    const api = useApiDirecciones();

    const formHandler = new FormHandler({
        validationSchema: direccionValidacionEsquema,
        api,
        dispatch,
    });


    useEffect(() => {
        async function cargar() {
            const dir = await api.obtener(direccionId);
            const direccion = {entity: {id: direccionId, direccion: dir}};
            dispatch({type: "reset", getDefault: () => direccion ?? defaultEntity});
        }

        if (direccionId > 0) {
            cargar().then();
        }
    }, []);


    const update = (value, name) => {
        dispatch({type: 'update', value, name});
        if (value.cambioDireccion === true) {
            dispatch({type: 'update', value: value.telefono, name: 'telefono'});
        }
    };


    const updateGeocerca = (value) => {
        dispatch({type: 'update', value: {...entity.direccion, geocerca: value}, name: 'direccion'});

    };


const guardar = async () => {
    const direccion = entity?.direccion;

    if (!direccion?.pais?.id) {
        alerts.aviso("Debe seleccionar un país.");
        return;
    }

    if (
        direccion.pais.id === constantes.paises.mexico &&
        direccion.rfc === "XEXX010101000"
    ) {
        alerts.aviso("RFC no aceptado para dirección en México.");
        return;
    }

    if (
        direccion.pais.id === constantes.paises.eua &&
        direccion.rfc === "XAXX010101000"
    ) {
        alerts.aviso("RFC no aceptado para dirección en el extranjero.");
        return;
    }

    try {
        await direccionValidacionEsquema.validate(entity, {
            abortEarly: false
        });
    } catch (error) {
        const errores = error.inner?.map(item => ({
            campo: item.path,
            mensaje: item.message,
            valor: item.value
        })) ?? [{
            campo: error.path,
            mensaje: error.message,
            valor: error.value
        }];

        console.error("Yup impidió guardar:", errores);
        return;
    }

    try {
        
        await formHandler.save(entity);

        if (formHandler.valdation?.result) {
            onSave();
        }
    } catch (error) {
        console.error("Error ejecutando el guardado:", error);
    }
};

    return (
        <>
            <div className="form-container full-height">
                <h5>Dirección</h5>
                <div className="form-row">
                    <ReadOnlyProvider defaultReadOnly={soloLectura}>
                        <Direccion value={entity?.direccion} name="direccion" onChange={update}
                                   mostrarCambioNombre={true} readOnly={soloLectura}
                                   errors={errors?.direccion}/>

                        <FieldDropDown time={800} name="geocerca" label="Geocerca" source="geocercas"
                                       params={{id: guid}} colMd={12} filter
                                       errors={errors?.direccion}
                                       value={entity?.direccion.geocerca} onChange={updateGeocerca}/>
                    </ReadOnlyProvider>
                </div>
                <div className="form-footer">
                    {!soloLectura &&
                        <Button label="Guardar" type="button" onClick={guardar}/>
                    }
                </div>
            </div>
        </>
    )
};

export default DetalleDireccion;
